import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import { RowName, RowSub, Footnote } from '../styles';
import RowAvatar from './RowAvatar';
import { initialsOf } from './TodayOnLeaveCard';
import { burnoutColor } from '../constants';

const Row = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid #F0F2F5;

  &:last-of-type { border-bottom: none; }
`;

const TopLine = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`;

const PersonLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const ScoreLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;
`;

const Track = styled.div`
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: #EEF1F5;
  overflow: hidden;
`;

const Fill = styled.div`
  width: ${({ $pct }) => $pct}%;
  height: 100%;
  border-radius: 3px;
  background: ${({ $color }) => $color};
`;

const Score = styled.div`
  width: 30px;
  text-align: right;
  font-size: 15px;
  font-weight: 800;
  color: ${({ $color }) => $color};
`;

export default function BurnoutRiskCard({ slice }) {
  const { t } = useTranslation();
  const items = slice.data || [];

  return (
    <DashboardCard
      cardKey="tukenmislik-risk-skoru"
      title={t('leaveDashboard.burnout.title')}
      meta={t('leaveDashboard.burnout.meta')}
      span={4}
      spanMd={3}
      loading={slice.loading}
      empty={items.length === 0}
    >
      <div>
        {items.map((item) => {
          const color = burnoutColor(item.score);
          return (
            <Row key={item.userId}>
              <TopLine>
                <PersonLine>
                  <RowAvatar
                    src={item.profilePicture}
                    name={item.fullName}
                    initials={initialsOf(item.fullName)}
                    size={24}
                  />
                  <RowName>{item.fullName}</RowName>
                </PersonLine>
              </TopLine>
              <RowSub>
                {[
                  item.department,
                  item.neverOnLeave
                    ? t('leaveDashboard.burnout.neverOnLeave')
                    : t('leaveDashboard.burnout.daysSinceLast', { days: item.daysSinceLastLeave }),
                ].filter(Boolean).join(' · ')}
              </RowSub>
              <ScoreLine>
                <Track><Fill $pct={item.score} $color={color} /></Track>
                <Score $color={color}>{item.score}</Score>
              </ScoreLine>
            </Row>
          );
        })}
        <Footnote>{t('leaveDashboard.burnout.footnote')}</Footnote>
      </div>
    </DashboardCard>
  );
}
